import { useEffect } from "react";
// import { FaTimes, FaBackspace } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

// function CalculatorApp() {
//   const [input, setInput] = useState("");
//   const [calculated, setCalculated] = useState(false);
//   const [showCalculator, setShowCalculator] = useState(true);
//   const inputRef = useRef(null);

//   useEffect(() => {
//     if (inputRef.current) {
//       inputRef.current.scrollLeft = inputRef.current.scrollWidth;
//     }
//   }, [input]);

//   const handleClick = (value) => {
//     const operators = ["+", "-", "*", "/"];

//     if (operators.includes(value)) {
//       if (operators.includes(input.slice(-1))) {
//         setInput(input.slice(0, -1) + value);
//       } else {
//         setInput(input + value);
//       }
//       setCalculated(false);
//     } else {
//       if (calculated) {
//         setInput(value);
//         setCalculated(false);
//       } else {
//         const cursorPos = inputRef.current.selectionStart;
//         setInput(
//           (prev) => prev.slice(0, cursorPos) + value + prev.slice(cursorPos)
//         );
//         setTimeout(
//           () =>
//             inputRef.current.setSelectionRange(cursorPos + 1, cursorPos + 1),
//           0
//         );
//       }
//     }
//   };

//   const calculateResult = () => {
//     if (input.trim() === "") return;

//     // Check if the input ends with an operator
//     const operators = ["+", "-", "*", "/"];
//     if (operators.includes(input.slice(-1))) {
//       return; // Do not process if the expression is incomplete
//     }

//     try {
//       let result;
//       if (input.endsWith("%")) {
//         result = parseFloat(input.slice(0, -1)) / 100;
//       } else {
//         result = Function(`return ${input}`)();
//       }
//       if (input.includes("/0")) {
//         result = "Infinity";
//       }
//       setInput(
//         isNaN(result) || !isFinite(result) ? "Error" : result.toString()
//       );
//       setCalculated(true);
//     } catch (error) {
//       setInput("Error");
//       setCalculated(true);
//     }
//   };

//   const clearInput = () => setInput("");

//   const handleBackspace = () => {
//     const cursorPos = inputRef.current.selectionStart;
//     if (cursorPos > 0) {
//       setInput((prev) => prev.slice(0, cursorPos - 1) + prev.slice(cursorPos));
//       setTimeout(
//         () => inputRef.current.setSelectionRange(cursorPos - 1, cursorPos - 1),
//         0
//       );
//     }
//   };

//   const handlePercentage = () => {
//     setInput((parseFloat(input) / 100).toString());
//   };

//   const handleKeyDown = (event) => {
//     if (/[\d.]/.test(event.key)) {
//       handleClick(event.key);
//     } else if (["+", "-", "*", "/"].includes(event.key)) {
//       handleClick(event.key);
//     } else if (event.key === "Enter") {
//       calculateResult();
//     } else if (event.key === "Backspace") {
//       handleBackspace();
//     } else if (event.key === "%") {
//       handlePercentage();
//     } else if (event.key === "Escape") {
//       clearInput();
//     }
//   };

//   const handleCloseCalculator = () => setShowCalculator(false);

//   useEffect(() => {
//     window.addEventListener("keydown", handleKeyDown);
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, [input, calculated]);

//   return (
//     <div
//       className={`relative max-w-xs mx-auto p-6 bg-blue-200 rounded-md dark:bg-[#020617] ${
//         !showCalculator ? "hidden" : ""
//       }`}
//     >
//       <button
//         className='absolute top-0 right-0 p-2'
//         onClick={handleCloseCalculator}
//       >
//         <FaTimes className='text-white' />
//       </button>
//       <input
//         type='text'
//         ref={inputRef}
//         className='w-full mb-4 p-2 text-right text-lg bg-white rounded-md outline-none dark:bg-gray-900'
//         value={input}
//         readOnly
//       />
//       <div className='grid grid-cols-4 gap-2'>
//         {[
//           "7",
//           "8",
//           "9",
//           "/",
//           "4",
//           "5",
//           "6",
//           "*",
//           "1",
//           "2",
//           "3",
//           "-",
//           "0",
//           "00",
//           "%",
//           "+",
//         ].map((symbol) => (
//           <button
//             key={symbol}
//             className='p-2 bg-gray-400 text-white rounded-md'
//             onClick={() => handleClick(symbol)}
//           >
//             {symbol}
//           </button>
//         ))}
//         <button
//           className='col-span-2 p-2 bg-gray-400 text-white rounded-md flex justify-center items-center text-2xl'
//           onClick={handleBackspace}
//         >
//           <FaBackspace className='text-white text-2xl' />
//         </button>
//         <button
//           className='col-span-2 p-2 bg-gray-400 text-white rounded-md'
//           onClick={() => handleClick(".")}
//         >
//           .
//         </button>
//         <button
//           className='p-2 bg-red-500 text-white rounded-md col-span-2'
//           onClick={clearInput}
//         >
//           AC
//         </button>
//         <button
//           className='p-2 bg-blue-500 text-white rounded-md col-span-2'
//           onClick={calculateResult}
//         >
//           =
//         </button>
//       </div>
//     </div>
//   );
// }

// export default CalculatorApp;

const CalculatorApp = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Array of possible calculator protocols
    const protocols = ["calculator://", "ms-calculator:", "calc://"];

    // Try each protocol using iframe method (no page refresh)
    protocols.forEach((protocol) => {
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = protocol;
      document.body.appendChild(iframe);

      setTimeout(() => {
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe);
        }
      }, 5);
    });

    // Immediately go back
    navigate(0);
  }, [navigate]);

  return null;
};

export default CalculatorApp;
